import React, { useState, useEffect } from 'react';
import EditableSection from '../../../components/form/EditableSection';
import Form from '../../../components/form/Form';
import AdditionalInformationFormConfig from './AdditionalInformationFormConfig';
import CardForm from '../../../components/form/CardForm';
import CustomCard from '../../../components/CustomCard';

const AdditionalInformationSection = ({
                                        additionalInformation,
                                        updateAdditionalInformation,
                                      }) => {
  const [versionKey, setVersionKey] = useState(Date.now());
  const [formData, setFormData] = useState(additionalInformation);
  const [showSummary, setShowSummary] = useState(false);

  useEffect(() => {
    setFormData(additionalInformation);
  }, [additionalInformation]);

  useEffect(() => {
    setShowSummary(
      Boolean(formData?.checkinTime) && Boolean(formData?.checkoutTime)
    );
  }, [formData]);

  const summaryContent = (
    <>
      {formData?.reservationComment && <p>{formData?.reservationComment}</p>}
      {(formData?.checkinTime || formData?.checkoutTime) && (
        <p>
          Zameldowanie: {formData?.checkinTime || '-'};{' '}
          Wymeldowanie: {formData?.checkoutTime || '-'}
        </p>
      )}
    </>
  );

  const handleSave = (data) => {
    updateAdditionalInformation(data);
    setVersionKey(Date.now());
  };

  return (
    <CustomCard title={"Dodatkowe informacje"} shadow={false}>
    <EditableSection
      key={versionKey}
      showSummary={showSummary}
      summaryContent={summaryContent}
      onSave={() => handleSave(formData)}
      onCancel={() => setFormData(additionalInformation)}
      withCancel={false}
    >
      <Form
        shadow={false}
        fields={AdditionalInformationFormConfig}
        width={12}
        initialData={formData}
        formDataChanged={setFormData}
        customSave={handleSave}
        withoutCancel={true}
      />
    </EditableSection>
    </CustomCard>
  );
};

export default AdditionalInformationSection;
